import React from 'react';
import { Radar } from 'react-chartjs-2';

interface Props {
  title: string;
  itens?: string[];
  values?: number[];
  benchmarkValues?: number[];
  displayTickLabel?: boolean;
  pinkBackground?: boolean;
}

const KIChart: React.FC<Props> = ({
  itens,
  values,
  displayTickLabel = true,
}) => {
  const options: any = {
    scale: {
      min: 0,
      max: 100,
      ticks: {
        display: false,
        maxTicksLimit: 3,
        suggestedMin: 0,
        suggestedMax: 10,
        showLabelBackdrop: false,
        fontColor: '#f2f2f2',
        fontSize: 16,
      },
      gridLines: { color: '#f2f2f2', lineWidth: 3 },
      angleLines: { color: '#f2f2f2', lineWidth: 0.2 },
      pointLabels: { display: false },
    },
    plugins: {
      legend: {
        labels: {
          boxWidth: 0,
        },
      },
    },
    legend: {
      labels: {
        boxWidth: 0,
      },
      display: false,
    },
  };

  const data = {
    labels: displayTickLabel ? itens : Array(itens?.length).fill(''),
    datasets: [
      {
        label: '',
        data: values || [],
        fill: true,
        backgroundColor: 'rgba(16, 177, 132, 0.2)',
        borderColor: '#a52024',
        borderDash: [5, 5],
        pointBackgroundColor: '#26d9b5',
        pointBorderColor: '#1a342bff',
        pointHoverBackgroundColor: '#1dcd75ff',
        pointHoverBorderColor: 'rgba(230, 131, 51)',
      },
    ],
  };

  return (
    <>
      <Radar data={data} options={options} />
    </>
  );
};

export default KIChart;
